import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentsComponent } from './payments.component';
import { RequestPaymentComponent } from './request-payment/request-payment.component';
import { ViewRequestedPaymentComponent } from './request-payment/view-requested-payment/view-requested-payment.component';
import { RequestedPaymentComponent } from './requested-payment/requested-payment.component';


const routes: Routes = [
  {
    path: 'payments',
    data: { title: 'Payments'
  },
    children: [
      { path: '', component: PaymentsComponent },
      {
        path: 'request-payment',
        data: {
            title: 'Request payment'
        },
        component: RequestPaymentComponent
    },
    {
      path: 'view-requested-payment/:paymentDetails',
      data: {
          title: 'View Request payment'
      },
      component: ViewRequestedPaymentComponent
  },
  {
    path: 'requested-payment',
    data: {
        title: 'Requested payment'
    },
    component: RequestedPaymentComponent
},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentsRoutingModule { }
